import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from "../authentication.service";
import { Router } from '@angular/router';

@Component({
    selector: 'app-after-login',
    template: '',
    providers: [AuthenticationService]
})

// [Tigran] Due to the bug in angular we need this hack to make login work with
// resolver on the final landing page.
export class AfterLoginPage implements OnInit {

    constructor(
        private router: Router,
    ) {}

    ngOnInit() {
        this.router.navigate(['/']);
    }
}
